export const shapes = {
  "border-radius-0": 0,
  "border-radius-1": 2,
  "border-radius-2": 4,
  "border-radius-3": 8,
  "border-radius-4": 12,
  "border-radius-half": 1000,
};

export type CascadiaShapeTypes = typeof shapes;
export type CascadiaShape = keyof CascadiaShapeTypes;
